/**
 * 互动邀请数据
 */
let event = require('cocos/framework/components/event')

let InteractiveInviteDataEvent = {
    ProgressChange: "InteractiveInviteProgressChange",    // 进度变化
    CanGetChange: "InteractiveInviteCanGetChange",    // 互动奖励数变更
    CountChange: "InteractiveInviteCountChange",    // 领取进度奖励次数变更
    CDChange: "InteractiveInviteCDChange",  // 下次可领进度奖励时间戳变更
}

let InteractiveInviteData = xClass("InteractiveInviteData", event)

InteractiveInviteData.prototype.ctor = function (serverData) {
    let self = this;
    self.potentialCanGet = serverData.potentialCanGet;    // 兴趣好友可领取奖励次数
    self.existCanGet = serverData.friendcloudCanGet; // 同玩好友可领取奖励次数
    self.todayPotentialGot = serverData.todayPotentialGot;  // 兴趣好友今日已领取奖励的次数
    self.todayExistGot = serverData.todayFriendcloudGot;  // 同玩好友今日已领取奖励的次数
    self.progress = serverData.progress;   // 奖励进度
    self.time = serverData.time;  // 下次领取进度奖励时间
    self.count = serverData.count;  // 领取进度奖励次数

    self.canGet = self.potentialCanGet + self.existCanGet;
    self.bind(self);
}

InteractiveInviteData.prototype.update = function (serverData) {
    let self = this;
 
    let postCanGet = updateCanGetInfo(self, serverData);     
    let [postProgress, postCount, postTime] = updateProgressInfo(self, serverData);

    if (postCanGet)
        self.dispatchEvent({name: InteractiveInviteDataEvent.CanGetChange})
    if (postProgress)
        self.dispatchEvent({name: InteractiveInviteDataEvent.ProgressChange})
    if (postCount)
        self.dispatchEvent({name: InteractiveInviteDataEvent.CountChange})
    if (postTime)
        self.dispatchEvent({name: InteractiveInviteDataEvent.CDChange})
}

/**
 * 进度增加
 */
InteractiveInviteData.prototype.progressAdd = function() {
    let self = this;
    self.progress = self.progress + 1
    self.dispatchEvent({name: InteractiveInviteDataEvent.ProgressChange})

}

/**
 * 更新领取互动奖励应答数据
 */
InteractiveInviteData.prototype.updateInterctiveRewardRsp = function(serverData) {
    let self = this;    

    let postCanGet = updateCanGetInfo(self, serverData); 
    if (postCanGet)
        self.dispatchEvent({name: InteractiveInviteDataEvent.CanGetChange});
}

/**
 * 更新进度领奖应答数据
 */
InteractiveInviteData.prototype.updateProgressRewardRsp = function(serverData) {
    let self = this;

    let [postProgress, postCount, postTime] = updateProgressInfo(self, serverData);

    if (postProgress)
        self.dispatchEvent({name: InteractiveInviteDataEvent.ProgressChange});
    if (postCount)
        self.dispatchEvent({name: InteractiveInviteDataEvent.CountChange});
    if (postTime)
        self.dispatchEvent({name: InteractiveInviteDataEvent.CDChange})
}

/**
 * 获取剩余可领取进度奖励时间（毫秒）
 */
InteractiveInviteData.prototype.getCDInMillisec = function() {
    let remain = this.time - Localhost.time();
    return remain < 0? 0: remain;
}

/**
 * 更新互动奖励信息
 * @param {*} data 
 * @param {*} serverData 
 */
function updateCanGetInfo(data, serverData) {
    let self = data;
    let postCanGet = false;

    self.potentialCanGet = serverData.potentialCanGet;
    self.existCanGet = serverData.friendcloudCanGet;
    self.todayPotentialGot = serverData.todayPotentialGot; 
    self.todayExistGot = serverData.todayFriendcloudGot;
    let newCanGet = self.potentialCanGet + self.existCanGet;
    if (self.canGet != newCanGet) {
        self.canGet = newCanGet;
        postCanGet = true;
    }
    return postCanGet;
}

/**
 * 更新进度奖励
 * @param {*} data 
 * @param {*} serverData 
 */
function updateProgressInfo(data, serverData) {
    let self = data;

    let postProgress = false, postCount = false, postTime = false;
    if (self.progress != serverData.progress) {
        self.progress = serverData.progress;
        postProgress = true;
    }
    if (self.count != serverData.count) {
        self.count = serverData.count; 
        postCount = true;
    }
    if (self.count != serverData.count) {
        self.count = serverData.count; 
        postCount = true;
    }
    if (self.time != serverData.time) {
        self.time = serverData.time; 
        postTime = true;
    }
    return [postProgress, postCount, postTime];
}

module.exports = { InteractiveInviteData, InteractiveInviteDataEvent }